import { render } from "./RestaurantsSection.vue?vue&type=template&id=1f06f44d&scoped=true"
import script from "./RestaurantsSection.vue?vue&type=script&lang=js"
export * from "./RestaurantsSection.vue?vue&type=script&lang=js"

import "./RestaurantsSection.vue?vue&type=style&index=0&id=1f06f44d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mkapp\\OneDrive\\Desktop\\Stage_Project\\Application_Front-end\\Moroccan-fork-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f06f44d"]])

export default __exports__